import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { UserService, AlertService } from '../service';
import { CallBackEndService } from '../call-back-end.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { ToastrService } from 'ngx-toastr'
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
declare var getHexAscii: any;
@Component({
  selector: 'app-fixed-deposit',
  templateUrl: './fixed-deposit.component.html',
  styleUrls: ['./fixed-deposit.component.css']
})
export class FixedDepositComponent implements OnInit {
  minTDAmt: number;
  maxTDAmt: number;
  minTDTenure: number;
  MaxTDTenure: number;
  minTDTenureType: any;
  tenureType = {
    "1":"Days",
    "2":"Months",
    "3":"Years"
  }
  maxTDTenureType: string;
  MaxTDTenureType: string;
  minTdTenInput: number;
  minTdTenInputError: string;
  minTdTenInputErrorMsg: string;
  maxTdTenInput: number;
  maxTdTenInputError: string;
  maxTdTenInputErrorMsg: string;
  tdTenTypeInNumb: number;
  tdTenMaxTypeInNumb: number;
  tdTenMinTypeInNumb: number;
  dayMonthPattern: string;
  FdTenure: number;
  FdTenure1: number;
  tentenureError: string;
  tenureErrDesc: string;

  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum1 = /^[0-9]+$/;
  bankName: any;

  private _jsonURL = 'assets/SampleUrl.json';
  openDepositFlagYN : string = 'N';

  ngOnInit(): void {

 this.spinnerService.show();
  const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      request.param2=sessionStorage.getItem("custNo");
      request.param1=getHexAscii("",request.param2),    
      this.webService.getResponse(request, 'getFDProductList').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
     
        if (response !== null && response.status === 'S200') {
          this.productList=response.param6;
               
        }
      });
 }
  FDType:string="";
  tdacctNo:string="";
  intrate:any;
  showIntTab='no';
  show:string='page0';
  tdAccounts=JSON.parse(sessionStorage.getItem('tdAccounts'));
  scoAccounts=JSON.parse(sessionStorage.getItem('scoAccounts'));
  fromAccountNoScb:any="";
  //depositAmount:string;
  depositAmount:number;
  months:string;
  days:string;
  validation:string;
  productList:any;
  fromaccountRequired:string='';
  MatIntRate:string;
  MatAmount:string;
  MatDate:string;
  fromAccBalance:string;
  intTrfAcc:any="";
  otp:string;
  tdAccNoRequired:string="";
  depositAmountRequired:string="";
  panNumber:string="";
  mobileNumber:string="";
  EmailID:string="";
  finalMsg:string;
  offset:string;
  totIntRate:string;
  nomineeName:string;
  depositAmountValid:string;
  depositAmountNoSpace:string;
  depositAmountSpeChar:string;
  depositAmountNotZero:string;
  IntrfaccRequired:string;
  regSpeci = /[-!$%^&*()_+|~=`{}[:;<>?,@#\]]/g;
  regchar = '/^[a-zA-Z]+$/';
  regexpspace = /\s+/;
  regZeroOnly = '^[0][0]*[0]$';
  regNum = /^.*[0-9]/;
  regexcap = /^.*?[A-Z]/;
  curRegExp = /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/;
  MonthsRequired:string;
  MonthsNoSpace:string;
  MonthsNumberOnly:string;
  DaysNumberOnly:string;
  DaysNoSpace:string;
  balance:string;
  inTrfAccRequired:string;
  otpRequired:string;
  ValidDaysValue:string;
  errorMsg:string;
  ValidDaysValueLess:string;
  Monthsgreater:string;
  IntRtError:string;
  tdAcctoDisp:string;
  noOfMonths:number;
  noOfDays : number;
   tdAcctoDispArray: any=[];
  constructor(
              private webService: CallBackEndService,
              private spinnerService: Ng4LoadingSpinnerService,
               private toastr: ToastrService,
               private http : HttpClient) {             
                    this.bankName = this.webService.getBankName();
                    this.getJSON().subscribe(data => {
                      // console.log(' Sample Json Obj: '+JSON.stringify(data));
                      this.openDepositFlagYN = data.openDepositFlagYN;
                      console.log('value received from sample url file is '+this.openDepositFlagYN);
                    }); 
                  }
   

    public getJSON(): Observable<any> {
      return this.http.get(this._jsonURL);
    }
  getInterestRate()
  {
   this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      request.param1=getHexAscii("",this.FDType),
      request.param2=this.FDType;
      this.webService.getResponse(request, 'getTDInterestRate').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
     
        if (response !== null && response.status === 'S200') {
         
               this.intrate=response.param6;
                this.showIntTab='yes';
               console.log("len--"+this.intrate);
               for(var i=0;i<this.intrate.length;i++)
               {
                 console.log(this.intrate.intRate);

               }

        }else if (response !== null)
        {
          this.IntRtError=response.statusDescription;
            this.showIntTab='no';
        }
      });
    }
  openPage1()
  {
	//this.show='page1';
	  const request: IbRequest = new IbRequest();
	  let response: IbResponse = null;
	    this.spinnerService.show();
      request.param1=getHexAscii("",sessionStorage.getItem('custNo')+this.FDType),
	  request.param2=sessionStorage.getItem('custNo');
	  request.param3= this.FDType;
      this.webService.getResponse(request, 'getTDAccountsForOpening').subscribe((data: IbResponse) => {
		   this.spinnerService.hide();
        response = data;
     
        if (response !== null && response.status === 'S200') {
			console.log("response.param6.length"+response.param6.length)
		 if(response.param6.length>0){
      this.tdAccounts=response.param6;
      this.minTDAmt = +response.param5.minTDAmt;
      this.maxTDAmt = +response.param5.maxTDAmt;
      this.minTDTenure = +response.param5.minTDTenure;
      this.MaxTDTenure = +response.param5.MaxTDTenure;
      let tdTenType : number = +response.param5.minTDTenureType;
      let tdTenTypeMax : number = +response.param5.MaxTDTenureType;
      this.tdTenMinTypeInNumb=tdTenType;
      this.tdTenMaxTypeInNumb = tdTenTypeMax;
        if(tdTenType==tdTenTypeMax){
           this.dayMonthPattern = 'no';
           if(tdTenType==1){
            this.minTDTenureType = "Days";
            this.MaxTDTenureType = "Days";
          }else if(tdTenType==2){
            this.minTDTenureType = "Months";
            this.MaxTDTenureType = "Months";
          }else if(tdTenType==3){
            this.minTDTenureType = "Years";
            this.MaxTDTenureType = "Years";
          }  
        }else{
          this.dayMonthPattern = 'yes';
     // this.tdTenMinTypeInNumb=tdTenType;
      if(tdTenType==1){
        this.minTDTenureType = "Days";
        
      }else if(tdTenType==2){
        this.minTDTenureType = "Months";
        
      }else if(tdTenType==3){
        this.minTDTenureType = "Years";
       
      }   

      //this.tdTenMaxTypeInNumb = tdTenTypeMax;
      if(tdTenTypeMax==1){
        this.MaxTDTenureType = "Days";
      }else if(tdTenTypeMax==2){
        this.MaxTDTenureType = "Months";
      }else if(tdTenTypeMax==3){
        this.MaxTDTenureType = "Years";
      }
    }
        this.show='page1';
        
		   }
		   else{
			   this.toastr.error("", 'First Open Your Account Under '+this.FDType+' From Branch',{'easeTime':0,'closeButton':true,'timeOut':5000}); 
		   }

        }
      });
  }
  openPage2(){
  //  if(this.tdacctNo===undefined||this.tdacctNo===null||this.tdacctNo==="")
  // {
  //   this. tdAccNoRequired='no';
  // }else
    if(this.fromAccountNoScb===null||this.fromAccountNoScb===undefined||this.fromAccountNoScb==='')
   {
     this.fromaccountRequired='no';
   }else{
     this.show='page2';
    }
 
  }
  backToPage1(){
    this.show='page1';
  }
  validateOld(){
 const request: IbRequest = new IbRequest();
    //  if(this.depositAmount===null||this.depositAmount===""||this.depositAmount===undefined)
    // {
    //   this.depositAmountRequired='no';
    // }else if(parseFloat(this.depositAmount)<=0)
    // {
    //    this.depositAmountNotZero='no';
    // }
    // else if(this.depositAmount.match(this.regexpspace)){
    //   this.depositAmountNoSpace='no';

    // }else if(this.depositAmount.match(this.regSpeci))
    // {
    //   this.depositAmountSpeChar='no';
    // }else if(!this.depositAmount.match(this.curRegExp))
    // {
    //     this.depositAmountValid='no';
    // } else  if((this.months===""||this.months===undefined||this.months===null)&&(this.days===""||this.days===undefined||this.days===null))
    //       {
    //         this.toastr.error("Please Enter Months And Days", 'Fixed Deposit',{'easeTime':0,'closeButton':true,'disableTimeOut':true});
    //           console.log("TEST--6-");
              
    // }else 
    // {
      if(this.validateAmount()){

      console.log("TEST---"+this.months+"__"+this.days);
    
         if(this.months===""||this.months===undefined||this.months===null)
         {
              this.months="0";
              console.log("TEST--7-");
     }
       if(this.days===""||this.days===undefined||this.days===null)
       {
                this.days="0";
                console.log("TEST--8-");
      }
     
     if(!this.months.match(this.regNum))
        {
           this.MonthsNumberOnly='no';
         }else if(this.months.match(this.regexpspace))
        {
           this.MonthsNoSpace='no';
        }else  if(!this.days.match(this.regNum))
       {
         this.DaysNumberOnly='no';
       }else if(parseInt(this.months)>120)
        {
           this.Monthsgreater='no';
        }else if(this.days.match(this.regexpspace))
       {
         this.DaysNoSpace='no';
       }else/* if(parseInt(this.days)<15){

         this.ValidDaysValueLess='no';
      }else */if(parseInt(this.days)>30){

        this.ValidDaysValue='no';
       } else
       {
            let response: IbResponse = null;
            this.spinnerService.show();
            request.param2=this.fromAccountNoScb;
            request.param3=this.tdacctNo;
            request.param5=this.FDType;
          //   var details={
          //      "CustNo":sessionStorage.getItem("custNo"),
          //      "NoOfMonths":this.months,
          //      "NoOfDays":this.days,
          //      "Amt":this.depositAmount,
          //  };
          var details={
            "CustNo":sessionStorage.getItem("custNo"),
            "minTDTenureType" : this.tdTenMinTypeInNumb+'',
            "minTDTenureInput" : this.minTdTenInput+'',

            "MaxTDTenureType" : this.tdTenMaxTypeInNumb+'',
            "maxTDTenureInput" : this.maxTdTenInput+'',
            // "NoOfMonths":this.months,
            // "NoOfDays":this.days,
            "Amt":this.depositAmount,
            
          }
           request.param6=details;
           request.param1=getHexAscii("",request.param2+request.param3+request.param5),    
           this.webService.getResponse(request, 'FDValidation').subscribe((data: IbResponse) => {
                 this.spinnerService.hide();
                response = data;
            if (response !== null && response.status === 'S200') {
         
              this.validation='true';
              (document.querySelector('#depositAmount') as HTMLInputElement).readOnly = true;
                (document.querySelector('#months') as HTMLInputElement).readOnly = true;
                  (document.querySelector('#days') as HTMLInputElement).readOnly = true;
                   (document.querySelector('#ValBtn') as HTMLButtonElement).disabled = true;
              this.MatAmount=response.param3;
              this.MatDate=response.param4;
              this.MatIntRate=response.param2;
              this.panNumber=response.param5.panNo;
              this.mobileNumber=response.param5.mobileNo;
              this.EmailID=response.param5.emailId;
              this.offset=response.param5.offsetRate;
              this.totIntRate=response.param5.totalIntRate;
              this.nomineeName=response.param5.nomineeName;
              // this.toastr.success(response.param1, 'Fixed Deposit',{'easeTime':0,'timeOut':3000});
              
           }else{
           this.toastr.error(response.param1, 'Fixed Deposit',{'easeTime':0,'closeButton':true,'disableTimeOut':true});
          }
        });
      }
    }
    
  }
  validateFdTenreNew(){
    //convert into days 
    let minDays : number;
    let maxDays : number;
    let noOfCalcDays:number;
    if(this.noOfMonths!=undefined || this.noOfDays!=undefined){
      if(this.minTDTenureType==='Days'){
        minDays = this.minTDTenure;
      }else if(this.minTDTenureType==='Months'){
        minDays = this.minTDTenure*30;
      }else{
        minDays = this.minTDTenure*365;
      } 
       // got min days now find max days and noOfInput days
      if(this.MaxTDTenureType==='Days'){
        maxDays = this.MaxTDTenure;
      }else  if(this.MaxTDTenureType==='Months'){
        maxDays = this.MaxTDTenure*30;
      }else if(this.MaxTDTenureType==='Years'){
        maxDays = this.MaxTDTenure*365;
      }
      console.log('min days: '+minDays+'   maxDays : '+maxDays);
      this.noOfDays = this.noOfDays!=undefined ? this.noOfDays : 0 ;
      this.noOfMonths = this.noOfMonths!=undefined ? this.noOfMonths : 0 ;
      if(this.noOfDays<31){
        noOfCalcDays = this.noOfDays + this.noOfMonths*30;
        console.log('noOfCalcDays : '+noOfCalcDays);
        if(noOfCalcDays>=minDays && noOfCalcDays<=maxDays){
          this.tentenureError='';
          this.tenureErrDesc='';
          return true;
        }else{
          this.tentenureError='yes';
        this.tenureErrDesc='Select Tenure in the given Range';
        return false;
        }
      }else{
        this.tentenureError='yes';
        this.tenureErrDesc='Number Of Days Cant be greater than 30';
        return false;
      }

    }else{
      this.tentenureError='yes';
        this.tenureErrDesc='Please enter tenure day or month';
        return false;
    }

  }
  removeErrorMsg(){
    this.tentenureError='';
    this.tenureErrDesc='';
  }
  validate(){
    
   // if(this.validateAmount() && ( ( this.validateMinTDTenute() && this.validateMaxTDTenute() ) || (this.validateFdTenure()) ) )
   // if(this.validateAmount() && this.dayMonthPattern==='yes' ?  this.validateMinTDTenute() && this.validateMaxTDTenute()  : this.validateFdTenure() )
   if(this.validateAmount() && this.validateFdTenreNew())//nthPattern==='yes' ?  this.validateFdTenreForDayMonth()  : this.validateFdTenureForOneType()  ) 
   {
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
            this.spinnerService.show();
            request.param2=this.fromAccountNoScb;
            request.param3=this.tdacctNo;
            request.param5=this.FDType;
          //   var details={
          //      "CustNo":sessionStorage.getItem("custNo"),
          //      "NoOfMonths":this.months,
          //      "NoOfDays":this.days,
          //      "Amt":this.depositAmount,
          //  };
          var details;
          details = {
             "CustNo":sessionStorage.getItem("custNo"),
             "NoOfMonths":this.noOfMonths+'',
             "NoOfDays":this.noOfDays+'',
             "Amt":this.depositAmount,
          }
          // if(this.dayMonthPattern==='yes'){

          //   details={
          //     "CustNo":sessionStorage.getItem("custNo"),
  
          //     "minTDTenureType" : this.tdTenMinTypeInNumb+'',
          //     "minTDTenureInput" : this.minTdTenInput+'',
  
          //     "MaxTDTenureType" : this.tdTenMaxTypeInNumb+'',
          //     "maxTDTenureInput" : this.maxTdTenInput+'',
          //     // "NoOfMonths":this.months,
          //     // "NoOfDays":this.days,
          //     "Amt":this.depositAmount,
              
          //   }
          // }else{
          //   details={
          //     "CustNo":sessionStorage.getItem("custNo"),
  
          //     "minTDTenureType" : 1+'',
          //     "minTDTenureInput" : this.FdTenure1+'',   //days
  
          //     "MaxTDTenureType" : 2+'',
          //     "maxTDTenureInput" : this.FdTenure+'',   //months

            
            
          //     "Amt":this.depositAmount,
              
          //   }
          // }
         
           request.param6=details;
           request.param1=getHexAscii("",request.param2+request.param3+request.param5),    
           this.webService.getResponse(request, 'FDValidation').subscribe((data: IbResponse) => {
                 this.spinnerService.hide();
                response = data;
            if (response !== null && response.status === 'S200') {
         
              this.validation='true';
              (document.querySelector('#depositAmount') as HTMLInputElement).readOnly = true;
                // (document.querySelector('#') as HTMLInputElement).readOnly = true;
              // if(this.dayMonthPattern==='yes'){
              //   (document.querySelector('#months') as HTMLInputElement).readOnly = true;
              //   (document.querySelector('#days') as HTMLInputElement).readOnly = true;
              // }
              // else{
              //   (document.querySelector('#months1') as HTMLInputElement).readOnly = true;
              //   (document.querySelector('#days1') as HTMLInputElement).readOnly = true;
              // }
              (document.querySelector('#months') as HTMLInputElement).readOnly = true;
              (document.querySelector('#days') as HTMLInputElement).readOnly = true;
                   (document.querySelector('#ValBtn') as HTMLButtonElement).disabled = true;
              this.MatAmount=response.param3;
              this.MatDate=response.param4;
              this.MatIntRate=response.param2;
              this.panNumber=response.param5.panNo;
              this.mobileNumber=response.param5.mobileNo;
              this.EmailID=response.param5.emailId;
              this.offset=response.param5.offsetRate;
              this.totIntRate=response.param5.totalIntRate;
              this.nomineeName=response.param5.nomineeName;
             // this.toastr.success(response.param1, 'Fixed Deposit',{'easeTime':0,'timeOut':3000});
              
           }else{
           this.toastr.error(response.param1, 'Fixed Deposit',{'easeTime':0,'closeButton':true,'disableTimeOut':true});
          }
        });
    }
  }
  fromAcctValidate()
  {
   if(this.fromAccountNoScb===null||this.fromAccountNoScb===undefined||this.fromAccountNoScb==='')
   {
     this.fromaccountRequired='no';
   }
  }
  removeMessageFromAcct(){
    this.fromaccountRequired='';
  }
  openPage3()
  {
     if(this.intTrfAcc===""||this.intTrfAcc===undefined||this.intTrfAcc===null)     
    {
      this.inTrfAccRequired='no';
    }else{
    this.spinnerService.show();

       const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      console.log("come inside");
      //this.isLoad = true;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName'));
      request.param2 =sessionStorage.getItem('storedUserName');
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
        //this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log('Otp :' + response.param1);
          this.show='page3';
      
        } else if (response !== null) {
         
          // this.error = response.param1;
          // this.disableSub1Btn=false;
        } else {
          // this.error = 'Something Went Wrong Please Contact Customer Care';
          // this.disableSub1Btn=false;
        }
      });

    }


  }
  resetForm()
  {
    (document.querySelector('#depositAmount') as HTMLInputElement).readOnly = false;
    (document.querySelector('#months') as HTMLInputElement).readOnly = false;
    (document.querySelector('#days') as HTMLInputElement).readOnly = false;
    (document.querySelector('#ValBtn') as HTMLButtonElement).disabled = false;
    this.MatDate="";
    this.depositAmount=undefined;
    this.days="";
    this.MatAmount="";
    this.MatIntRate="";
    this.months="";
    this.intTrfAcc="";
    this.validation="false";
  }
  tdAccValiadte()
  {
 
  if(this.tdacctNo===undefined||this.tdacctNo===null||this.tdacctNo==="")
  {
    this. tdAccNoRequired='no';
  }
  }
  removeTdAccMsgs(){
     this.tdAccNoRequired='';
  }
  openPage4()
  {

    // if(this.otp===""||this.otp===undefined||this.otp===null)
     if(this.validateOtp())
    // {
    //   this.otpRequired='no';
    // }else
    {
   const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      console.log("come inside");
      //this.isLoad = true;
    this.spinnerService.show();
      request.param2 =this.fromAccountNoScb ;
      request.param3=this.tdacctNo;
      request.param4=this.intTrfAcc;
      request.param5=this.FDType;
      var details={
                "CustNo":sessionStorage.getItem('custNo'),
                // "NoOfMonths":this.months,
                // "NoOfDays":this.days,
                "Amt":this.depositAmount,
                "IntRate":this.MatIntRate,
                "MatValue":this.MatAmount,
                "MatDate":this.MatDate,
                "OffSetRate":"0.0",
                "OTP":getHexAscii('',this.otp),
                "userName":sessionStorage.getItem('storedUserName'),
                "NoOfMonths":this.noOfMonths+'',
                "NoOfDays":this.noOfDays+'',

      };
      request.param6=details;
        request.param1 = getHexAscii('',  request.param2+request.param3+request.param4+request.param5);
      this.webService.getResponse(request, 'openingFDAccount').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
           if (data !== null && data.status ==='S200') {
         this.show='page4';
         this.finalMsg=data.param1;
           }else{
             this.errorMsg=data.param1;
           }
    });
    }

  }
  // validateAmount()
  // {
  //   if(this.depositAmount===null||this.depositAmount===""||this.depositAmount===undefined)
  //   {
  //     this.depositAmountRequired='no';
  //   }else if(parseFloat(this.depositAmount)<=0)
  //   {
  //      this.depositAmountNotZero='no';
  //   }
  //   else if(this.depositAmount.match(this.regexpspace)){
  //     this.depositAmountNoSpace='no';

  //   }else if(this.depositAmount.match(this.regSpeci))
  //   {
  //     this.depositAmountSpeChar='no';
  //   }else if(!this.depositAmount.match(this.curRegExp))
  //   {
  //       this.depositAmountValid='no';
  //   }
  // }
  validateAmount(){
    if(this.depositAmount==undefined || this.depositAmount==0 || this.depositAmount==null){
      this.depositAmountRequired='no';
      return false;
    }else if(this.depositAmount<this.minTDAmt){
      this.depositAmountRequired='minCondFail';
      return false;
    }else if(this.depositAmount>this.maxTDAmt){
      this.depositAmountRequired='maxCondfail';
      return false;
    }else{
      this.depositAmountRequired='';
      return true;
    }
  }
  removeAmountMsgs()
  {
    this.depositAmountRequired='';
    this.depositAmountNoSpace='';
    this.depositAmountSpeChar='';
     this.depositAmountValid='';
     this.depositAmountNotZero='';
  }
  validateMonths()
  {
    if(!(this.months===""||this.months===null||this.months===undefined))
    {
    
       if(!this.months.match(this.regNum))
        {
           this.MonthsNumberOnly='no';
         }else if(this.months.match(this.regexpspace))
        {
           this.MonthsNoSpace='no';
        }else if(parseInt(this.months)>120)
        {
           this.Monthsgreater='no';
        }
  }
 }
 validateFdTenure(){
   if(this.FdTenure==undefined && this.FdTenure1==undefined){
     this.tentenureError='yes';
     this.tenureErrDesc='Enter Tenure';
     return false;
   }else if( this.FdTenure1!=undefined || this.FdTenure!=undefined){
     this.FdTenure = this.FdTenure!=undefined ? this.FdTenure : 0;   //months
     this.FdTenure1 = this.FdTenure1!=undefined ? this.FdTenure1 : 0;   //days
     console.log('FdTenure: '+this.FdTenure+' FdTenure1 : '+this.FdTenure1);
     let daysInMontgs = this.FdTenure1/30;
      let totalMonths = this.FdTenure+daysInMontgs;
      console.log('totalMonths: '+totalMonths+'   daysInMontgs: '+daysInMontgs);
      if(totalMonths>=this.minTDTenure){
        this.tentenureError='';
        this.tenureErrDesc='';
        return true;
      }else{
        this.tentenureError='yes';
        this.tenureErrDesc='Enter Tenure';
        return false;
      }
   }
 }
 validateFdTenure1(){
   if(this.FdTenure==undefined || this.FdTenure<this.minTDTenure || this.FdTenure>this.MaxTDTenure){
    this.minTdTenInputError = 'yes';
    this.minTdTenInputErrorMsg = 'Enter Tenure Between '+this.minTDTenure+' '+this.minTDTenureType+' to '+this.MaxTDTenure+' '+this.MaxTDTenureType;
    return false;
   }else{
    this.minTdTenInputError = '';
    this.minTdTenInputErrorMsg = '';
    return true;
   }
 }
 changeValidateFdTenure(){
  this.minTdTenInputError = '';
  this.minTdTenInputErrorMsg = '';
 }

 validateMinTDTenute(){
  if(this.maxTdTenInput==undefined){
     this.maxTdTenInput=0;
  }
  if( this.maxTdTenInput==this.MaxTDTenure) {
    if( this.minTdTenInput==0 || this.minTdTenInput==undefined ){
      this.minTdTenInput==0
      this.minTdTenInputError = '';
      this.minTdTenInputErrorMsg = '';
      return true;
    }else{ 
    this.minTdTenInputError = 'yes';
    this.minTdTenInputErrorMsg = 'Selected Tenure Exceeds Tenure Range';
    return false;
    }
  }
  else if(this.minTdTenInput==0 || this.minTdTenInput==undefined ){
    this.minTdTenInputError = 'yes';
    this.minTdTenInputErrorMsg = 'Please Enter Minimum Tenure';
    return false;
  }else if(this.minTdTenInput<this.minTDTenure && (this.maxTdTenInput<=0 || this.maxTdTenInput>this.MaxTDTenure) ){
    this.minTdTenInputError = 'yes';
    this.minTdTenInputErrorMsg = 'Minimum tenure Should be Greater than '+this.minTDTenure+' '+this.minTDTenureType;
    return false;
  }else{
    this.minTdTenInputError = '';
    this.minTdTenInputErrorMsg = '';
    return true;
  }
 }
 changeValidateMinTDTenute(){
  this.minTdTenInputError = '';
  this.minTdTenInputErrorMsg = '';
 }
 validateMaxTDTenute(){
  
  
   if(this.maxTdTenInput!=undefined){
   if(this.maxTdTenInput>this.MaxTDTenure ){
    this.maxTdTenInputError = 'yes';
    this.maxTdTenInputErrorMsg = 'Maximim tenure Can not be Greater than '+this.MaxTDTenure+' '+this.MaxTDTenureType;
    return false;
  }
  // else if(this.maxTdTenInput>this.MaxTDTenure && this.minTdTenInput!=0){
  //   this.maxTdTenInputError = 'yes';
  //   this.maxTdTenInputErrorMsg =  'If Maximim tenure is '+this.MaxTDTenure+' '+this.MaxTDTenureType+' Then min Tenure Must Be Zero';
  //   return false;
  // }
  else{
    this.maxTdTenInputError = '';
    this.maxTdTenInputErrorMsg = '';
    return true;
  }
}else if(this.maxTdTenInput==undefined || this.maxTdTenInput==null ){
  this.maxTdTenInput=0;
  return true;
}
 }
 changeValidateMaxTDTenute(){
  this.maxTdTenInputError = '';
  this.maxTdTenInputErrorMsg = '';
 }
  removeMonthsMsgs()
  {
     this.MonthsNumberOnly='';
     this.MonthsNoSpace='';
     this.Monthsgreater='';
  }
  validateDays()
  {
    if(!(this.days===""||this.days===null||this.days===undefined))
    {
        if(!this.days.match(this.regNum))
       {
         this.DaysNumberOnly='no';
       }else if(this.days.match(this.regexpspace))
       {
         this.DaysNoSpace='no';
       }else if(parseInt(this.days)>30){

        this.ValidDaysValue='no';
       }else if(parseInt(this.days)<15){

        this.ValidDaysValueLess='no';
       }
    }
  }
  removeDaysMsgs(){
    this.DaysNumberOnly='';
    this.DaysNoSpace='';
    this.ValidDaysValue='';
     this.ValidDaysValueLess='';
  }
  assignBalance()
  {
   const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 = getHexAscii('', this.fromAccountNoScb);
    request.param2 = this.fromAccountNoScb;
    this.spinnerService.show();
    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      this.spinnerService.hide();
      if (data !== null && data.status === 'S200') {
        this.balance = data.param5.clrBalanceStr;
       
      }
    });
   
  }
  removeIntTrfAccMsgs()
  {
      this.inTrfAccRequired='';
  }
    intTrfAccValidate()
  {
    console.log("test");
    if(this.intTrfAcc===""||this.intTrfAcc===undefined||this.intTrfAcc===null)     
    {
      this.inTrfAccRequired='no';
    }
  }
  validateOtp_old()
  {
    if(this.otp===""||this.otp===undefined||this.otp===null)
    {
      this.otpRequired='no';
    }
  }
  validateOtp() {
    if (this.otp === undefined || this.otp === '') {
      this.otpRequired = 'no';
     return false;
    }else if (this.otp.match(this.reg)) {
      this.otpRequired = 'specialChar';
      return false;
    }else if (!this.otp.match(this.regNum1)) {
      this.otpRequired = 'num';
      return false;
    } else if (this.otp.length!=6) {
      this.otpRequired = 'len';
      return false;
    }else{
      this.otpRequired = '';
      return true;
    }
  }
  removeOtpMsgs()
  {
       this.otpRequired='';
       this.errorMsg='';
  }
  clearFDRatesMsgs()
  {
    this.IntRtError='';
  }
  AccNoChange(event: Event)
  {
	   let selectElementText = event.target['options']
      [event.target['options'].selectedIndex].text;
	  console.log(selectElementText);
	  this.tdAcctoDisp=selectElementText;   
	   console.log("this.tdAcctoDisp"+this.tdAcctoDisp);
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/fixed-deposit/fixed-deposit.component.ts